import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../../../utils/api';

const useCostingSummaryData = ({ preloadedData }) => {
    const pre = preloadedData;

    const [costingSummaryData, setCostingSummaryData] = useState(() => pre?.costingSummary?.item1 || []);
    const [costingSummaryDataLoaded, setCostingSummaryDataLoaded] = useState(() => !!pre?.costingSummary?.item1);

    const loadCostingSummaryDataBackground = async () => {
        if (costingSummaryDataLoaded) return;
        try {
            const res = await authenticatedFetch('/ManagerReport/GetCostingSummaryData', {
                method: 'POST',
                body: JSON.stringify({}),
            });
            const result = await res.json();
            if (result.item2 == null) {
                setCostingSummaryData(result.item1);
                setCostingSummaryDataLoaded(true);
            }
        } catch (ex) {
            console.log('Background costing summary load failed:', ex);
        }
    };

    useEffect(() => {
        loadCostingSummaryDataBackground();
    }, []);

    return {
        costingSummaryData,
        setCostingSummaryData,
        costingSummaryDataLoaded,
        setCostingSummaryDataLoaded,
        loadCostingSummaryDataBackground,
    };
};

export default useCostingSummaryData;
